import 'form-request-submit-polyfill';

import NotificationHelper from './helpers/notification-helper';
import PageHelper from './helpers/page-helper';
import ParsleyHelper from './helpers/parsley-helper';
import MessageHelper from './helpers/message-helper';
import Page from './pages/page';
import Carousel from './components/cms/carousel';
import CategoryCarousel from './components/cms/category-carousel';
import '../templates/helpers/helpers';

export default class EpartsApp {
    Carousel = Carousel;
    CategoryCarousel = CategoryCarousel;

    private readonly currentPage: Page;

    constructor() {
        window.NotificationHelper = NotificationHelper.Instance;
        window.MessageHelper = MessageHelper;
        window.PageHelper = PageHelper;

        ParsleyHelper.setParsleyGlobalOptions();
        this.currentPage = PageHelper.initPage();
    }
}

window.Eparts = new EpartsApp();
